import React, { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import { FaTrash } from "react-icons/fa";
import { MdEditSquare } from "react-icons/md";
import AdminLoader from "../../components/common/loader/AdminLoader";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPageTitle } from "../../store/slices/pageSlice";
import CommaConvert from "../../utils/CommaConvert";
import { MdSearch } from "react-icons/md";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { createOrUpdatePartsInventory, deletePartsInventory, getAllPartsInventory } from "../../store/slices/partsInventorySlice";

const Subparts = () => {
  const USAComma = CommaConvert();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { data } = useSelector(state => state.partsInventory);

  const [form, setForm] = useState({
    parts: "",
    unitsAvailable: "",
  });
  const [loading, setLoading] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const [editingId, setEditingId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [assemblyData, setAssemblyData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'asc' // 'asc' or 'desc'
  });
  console.log("ghdhd assemblyData", assemblyData)


  useEffect(() => {
    dispatch(setCurrentPageTitle("Sub Parts"));
    dispatch(getAllPartsInventory());

  }, [dispatch]);


  // -----------------------------
  // FILTER DATA
  // -----------------------------


  // useEffect(() => {
  //     const filteredData = inventory?.filter((item) =>
  //         item.assembly.toLowerCase().includes(searchQuery.toLowerCase())
  //     );
  //     setAssemblyData(filteredData);
  // }, [inventory, searchQuery]);

  useEffect(() => {
    let filteredData = data?.filter((item) =>
      item.parts.toLowerCase().includes(searchQuery.toLowerCase())
    ) || [];

    // Apply sorting if sortConfig is set
    if (sortConfig.key) {
      filteredData = [...filteredData].sort((a, b) => {
        let aValue = a[sortConfig.key];
        let bValue = b[sortConfig.key];

        // For string comparison
        if (sortConfig.key === 'parts') {
          aValue = aValue?.toLowerCase() || '';
          bValue = bValue?.toLowerCase() || '';

          if (aValue < bValue) {
            return sortConfig.direction === 'asc' ? -1 : 1;
          }
          if (aValue > bValue) {
            return sortConfig.direction === 'asc' ? 1 : -1;
          }
          return 0;
        }

        // For number comparison (unitsAvailable)
        if (sortConfig.key === 'unitsAvailable') {
          aValue = Number(aValue) || 0;
          bValue = Number(bValue) || 0;

          if (sortConfig.direction === 'asc') {
            return aValue - bValue;
          } else {
            return bValue - aValue;
          }
        }

        return 0;
      });
    }

    setAssemblyData(filteredData);
  }, [data, searchQuery, sortConfig]);

  const handleSort = (key) => {
    let direction = 'asc';

    // If clicking the same column, toggle direction
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    } else if (sortConfig.key === key && sortConfig.direction === 'desc') {
      // If clicking the same column for third time, remove sorting
      setSortConfig({ key: null, direction: 'asc' });
      return;
    }

    setSortConfig({ key, direction });
  };

  // Helper function to get sort icon state
  const getSortIconState = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? 'up' : 'down';
    }
    return null;
  };

  // -----------------------------
  // INPUT HANDLERS
  // -----------------------------
  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "unitsAvailable") {
  //     if (!/^\d*$/.test(value)) return; // only numbers
  //   }

  //   setForm({ ...form, [name]: value });
  // };
  // -----------------------------
  // INPUT HANDLERS
  // -----------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "unitsAvailable") {
      if (!/^\d*$/.test(value)) return; // only numbers
      setForm({ ...form, [name]: value });
    } else if (name === "parts") {
      // Capitalize first letter of each word for parts
      const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);

      setForm({ ...form, [name]: capitalizedValue });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  // -----------------------------
  // SUBMIT / UPDATE
  // -----------------------------
  const handleSubmit = async () => {
    if (!form.parts.trim()) {
      enqueueSnackbar("Parts name is required", { variant: "warning" });
      return;
    }
    if (!form.unitsAvailable) {
      enqueueSnackbar("Units available is required", { variant: "warning" });
      return;
    }
    setLoading(true)
    try {
      let payload = [];

      if (editingId) {
        payload = [{ ...form, _id: editingId }];
      } else {
        payload = [{ ...form }];
      }

      await dispatch(createOrUpdatePartsInventory(payload)).unwrap();
      enqueueSnackbar(editingId ? "Parts Updated successfully!" : "Parts Added successfully!", {
        variant: "success",
      });

      dispatch(getAllPartsInventory());
      setForm({ parts: "", unitsAvailable: "" });
      setEditingId(null);
    } catch (error) {
      if (error.message === "Some parts already exist." && error.duplicates) {

        enqueueSnackbar("Same parts already exist.", { variant: "error" });
      } else {
        // For other errors, show generic error message
        enqueueSnackbar("Error saving data", { variant: "error" });
      }
    } finally {
      setLoading(false)
    }
  };


  // -----------------------------
  // DELETE RECORD
  // -----------------------------
  const handleDelete = async (id) => {
    setLoading(true);
    try {
      await dispatch(deletePartsInventory(id)).unwrap();
      enqueueSnackbar("Parts Deleted successfully!", { variant: "success" });



    } catch (error) {
      enqueueSnackbar("Error deleting record", { variant: "error" });
    } finally {
      if (assemblyData.length === 1) {
        setAssemblyData([])
      }
      setLoading(false);
      dispatch(getAllPartsInventory());
      setDeleteId(null);
      setIsModalOpen(false);
    }
  };


  // -----------------------------
  // EDIT RECORD
  // -----------------------------
  const handleEdit = (item) => {
    setEditingId(item._id);
    setForm({
      parts: item.parts,
      unitsAvailable: item.unitsAvailable.toString(),
    });
  };

  const handleCancel = () => {
    setEditingId(null);
    setForm({ parts: "", unitsAvailable: "" });
  };

  return (
    <div className="bg-[rgb(243,248,248)] pb-6 h-screen">
      {loading ? (
        <AdminLoader isLoading={loading} />
      ) : (
        <div className="relative pt-4">
          <div className="flex w-full relative top-6">
            {/* FORM */}
            <div className="mr-4 p-4 h-fit w-[30%] bg-white border border-gray-200 shadow-lg rounded-md">
              <h1 className="text-2xl mb-2 font-semibold">
                {editingId ? "Edit Sub Parts" : "Add Sub Parts"}
              </h1>
              <hr /><br />

              <div className="mx-4">
                <label>Sub Parts Name</label>
                <input
                  className="border w-full border-gray-400 rounded-md p-2 shadow-md outline-none"
                  type="text"
                  name="parts"
                  value={form.parts}
                  onChange={handleChange}
                  placeholder="Enter Sub Parts Name"
                />
              </div>

              <div className="mx-4 pt-5">
                <label>Units Available</label>
                <input
                  className="border w-full border-gray-400 rounded-md p-2 shadow-md outline-none"
                  type="text"
                  name="unitsAvailable"
                  value={form.unitsAvailable}
                  onChange={handleChange}
                  placeholder="Enter Units Available"
                />
              </div>

              <div className="mx-4 mt-8">
                <button
                  onClick={handleSubmit}
                  className="mr-2 py-1 px-5 bg-[#e32278] hover:bg-[#e12298] shadow-md text-white rounded-md"
                >
                  {editingId ? "Update" : "Submit"}
                </button>
                <button
                  onClick={handleCancel}
                  className="ml-2 py-1 px-5 bg-black hover:bg-white hover:text-black border border-black shadow-md text-white rounded-md"
                >
                  Cancel
                </button>
              </div>
            </div>

            {/* TABLE */}
            <div className="ml-4 w-[70%] p-4 bg-white border border-gray-200 shadow-lg rounded-md">
              <div className="w-full mb-2">
                <h1 className="text-2xl mb-2 font-semibold">Sub Parts Details</h1>
              </div>

              {/* SEARCH */}
              <div className="flex justify-end p-1 items-center">
                <div className="flex gap-2 p-1 items-center bg-[#e0e7ff] rounded-full">
                  <MdSearch className="w-5 h-5 text-gray-500" />
                  <input
                    type="text"
                    placeholder="Search Parts"
                    className="bg-[#e0e7ff] outline-none w-[80%]"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
              </div>
              <hr /><hr />

              <div className="w-full overflow-x-auto max-h-[70vh] border mt-2">
                <div className="min-w-full divide-y divide-gray-200">
                  {/* HEADER */}
                  <div className="bg-black text-white sticky top-0">
                    <div className="flex">
                      <div className="border p-2 w-[10%] text-center">Sr. No</div>
                      <div className="relative border p-2 w-[35%] text-center">
                        Sub Parts Name
                        <div className="absolute right-2 top-0 flex flex-col">
                          <div
                            className="cursor-pointer"
                            onClick={() => handleSort("parts")}
                          >
                            <ArrowDropUp
                              sx={{
                                fontSize: "22px",
                                color: getSortIconState("parts") === "up" ? "#fbbf24" : "inherit"
                              }}
                            />
                          </div>
                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() => handleSort("parts")}
                          >
                            <ArrowDropDown
                              sx={{
                                fontSize: "22px",
                                color: getSortIconState("parts") === "up" ? "#fbbf24" : "inherit"
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="relative border p-2 w-[35%] text-center">
                        Units Available
                        <div className="absolute right-2 top-0 flex flex-col">
                          <div
                            className="cursor-pointer"
                            onClick={() => handleSort("unitsAvailable")}
                          >
                            <ArrowDropUp
                              sx={{
                                fontSize: "22px",
                                color: getSortIconState("unitsAvailable") === "down" ? "#fbbf24" : "inherit"
                              }}
                            />
                          </div>
                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() => handleSort("unitsAvailable")}
                          >
                            <ArrowDropDown
                              sx={{
                                fontSize: "22px",
                                color: getSortIconState("unitsAvailable") === "down" ? "#fbbf24" : "inherit"
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="border p-2 w-[10%] text-center">Edit</div>
                      <div className="border p-2 w-[10%] text-center">Delete</div>
                    </div>
                  </div>

                  {/* ROWS */}
                  <div className="bg-white divide-y divide-gray-200">
                    {assemblyData?.length > 0 ? (
                      assemblyData.map((item, index) => (
                        <div className="flex" key={item._id}>
                          <div className="border p-2 w-[10%] text-center">
                            {index + 1}
                          </div>

                          <div className="border p-2 w-[35%] text-center">
                            {item.parts}
                          </div>

                          <div className="border p-2 w-[35%] text-center">
                            {USAComma(item.unitsAvailable)}
                          </div>

                          <div
                            className="border p-2 w-[10%] flex justify-center hover:bg-black hover:text-white cursor-pointer"
                            onClick={() => handleEdit(item)}
                          >
                            <MdEditSquare size={20} />
                          </div>

                          <div
                            className="border p-2 w-[10%] flex justify-center hover:bg-black hover:text-white cursor-pointer"
                            onClick={() => {
                              setDeleteId(item._id);
                              setIsModalOpen(true);
                            }}
                          >
                            <FaTrash size={18} />
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-center text-red-500 py-4">
                        No matching records found
                      </div>
                    )}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      )
      }

      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-[1400] bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] max-w-md">
            <h2 className="text-xl font-semibold mb-4 text-center">Confirm Deletion</h2>
            <p className="text-gray-700 mb-6 text-center">
              Are you sure you want to delete this Sub Part?
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => {
                  setIsModalOpen(false);
                }}
                className="px-4 py-2 rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 text-gray-700"
              >
                Cancel
              </button>
              <button
                onClick={() => handleDelete(deleteId)}
                className="px-4 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white font-semibold"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div >
  )
}

export default Subparts